import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { hideLoading, notifyError, showLoading } from '../../shared/notify.js';
import { passkeyAnmelden, PASSKEY_UNTERSTUETZT } from '../../shared/webauthn.js';

// The second step of a password login and the passwordless button. Both end at
// the same endpoint: whether an mfa cookie is in flight is what tells the server
// which path it is on, so neither needs to say.
async function ceremonieDurchfuehren(ziel) {
  const optionen = await http.post('/auth/login/passkey/options', {});

  // No overlay around the ceremony itself - the browser raises its own modal
  // dialog, and a spinner behind it only competes with it.
  const antwort = await passkeyAnmelden(optionen.data.data.optionen);

  showLoading('Anmeldung läuft …');
  await http.post('/auth/login/passkey/verify', { antwort });

  window.location.href = withFlash(ziel, 'angemeldet');
}

function fehlerZeigen(err, fallback) {
  hideLoading();
  notifyError(err?.response?.data?.message || err?.message || fallback);
}

export function initLoginPasskey() {
  const passwortlos = document.getElementById('passkey-passwortlos');
  const fortsetzen = document.getElementById('passkey-fortsetzen');
  const wiederherstellung = document.getElementById('wiederherstellung-form');

  if (!passwortlos && !fortsetzen && !wiederherstellung) return;

  // A browser without WebAuthn, or a page served over plain HTTP, can do
  // nothing here. Hiding the passwordless button is better than offering one
  // that only ever fails; the password form beside it still works.
  if (!PASSKEY_UNTERSTUETZT && passwortlos) {
    passwortlos.classList.add('hidden');
  }

  if (passwortlos) {
    passwortlos.addEventListener('click', async () => {
      passwortlos.disabled = true;
      try {
        await ceremonieDurchfuehren('/');
      } catch (err) {
        passwortlos.disabled = false;
        fehlerZeigen(err, 'Die Anmeldung mit Passkey ist fehlgeschlagen.');
      }
    });
  }

  if (fortsetzen) {
    fortsetzen.addEventListener('click', async () => {
      fortsetzen.disabled = true;
      try {
        await ceremonieDurchfuehren('/');
      } catch (err) {
        fortsetzen.disabled = false;
        fehlerZeigen(err, 'Der Passkey konnte nicht bestätigt werden.');
      }
    });
  }

  if (wiederherstellung) {
    wiederherstellung.addEventListener('submit', async (event) => {
      event.preventDefault();

      const feld = document.getElementById('wiederherstellung-code');
      const code = feld ? feld.value.trim() : '';
      if (!code) {
        notifyError('Bitte geben Sie einen Wiederherstellungscode ein.');
        return;
      }

      showLoading('Code wird geprüft …');

      try {
        await http.post('/auth/login/wiederherstellung', { code });
        window.location.href = withFlash('/settings', 'angemeldet');
      } catch (err) {
        fehlerZeigen(err, 'Der Wiederherstellungscode konnte nicht verwendet werden.');
      }
    });
  }
}
